import PropTypes from "prop-types";
import React from "react";
import { GridCell, gridConstants, GridContainer, GridFlexSpacer } from "../Grid";

const LayoutSmall = ({ children }) => {
    return (
        <GridContainer>
            <GridFlexSpacer/>
            <GridCell
                medium_columns={gridConstants.column.EIGHT}
                large_columns={gridConstants.column.SIX}
            >
                {children}
            </GridCell>
            <GridFlexSpacer/>
        </GridContainer>
    );
};

LayoutSmall.propTypes = {
    children: PropTypes.any,
};

export default LayoutSmall;
